import { render, staticRenderFns } from "./XwStatus.vue?vue&type=template&id=8b60fa28&scoped=true"
import script from "./XwStatus.vue?vue&type=script&lang=js"
export * from "./XwStatus.vue?vue&type=script&lang=js"
import style0 from "./XwStatus.vue?vue&type=style&index=0&id=8b60fa28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b60fa28",
  null
  
)

export default component.exports